import { Columns3 } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function CustomFieldsPage() {
  return (
    <PlaceholderPage
      icon={Columns3}
      title="Pola niestandardowe"
      description="Dodawaj i zarz\u0105dzaj polami niestandardowymi dla kontrahent\u00F3w, os\u00F3b, szans sprzeda\u017Cy i serwisu."
    />
  )
}
